import ApiService from "../../core/service/ApiService";
import {useEffect, useRef, useState} from "react";
import {Button, Collapse, Form, Input, Select, Typography} from "antd";
import { t } from 'i18next';
import moment from "moment";

export default function PosCancel({appointmentId, payment, posId, onSuccess}) {
    const formRef = useRef()
    const [error, setError] = useState(null)

    const onSubmit = async (values) => {
        setError(null)
        const posDevices = (await ApiService.Payment.GetPosDevices(appointmentId))?.data
        const pos = posDevices.find(device => device.id === payment.posId)

        const formData = formRef.current.getFieldsValue()
        const res = await ApiService.Payment.PavoCancelBody(payment?.id, formData.orderNo)

        if (!res.success) return

        let rawResponse = null
        let httpStatus = null
        let clientError = null
        let posData = null
        let logged = false

        const logPos = (success) => {
            if (logged) return
            logged = true
            ApiService.Payment.LogPosTransaction({
                appointmentId,
                paymentId: payment?.id,
                action: 'CANCEL',
                request: res.data,
                response: rawResponse,
                success: !!success,
                httpStatus,
                error: clientError,
            }).catch(() => { })
        }

        try {
            const posRes = await fetch(`${pos?.address}/CancelSale`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: res.data
            })
            httpStatus = posRes.status
            rawResponse = await posRes.text()

            if (!posRes.ok) {
                clientError = `HTTP ${posRes.status}`
                setError(t('POS device is not reachable!') + ` (${posRes.status})`)
                logPos(false)
                return
            }

            try { posData = JSON.parse(rawResponse) } catch (e) { posData = null }

            if (posData?.HasError) {
                setError(`${posData?.ErrorCode}: ${posData?.Message}`)
                logPos(false)
                return
            }

            const savePosRes = await ApiService.Payment.PavoCancel(payment?.id)

            logPos(true)

            if (savePosRes.success && !posData?.HasError) {
                onSuccess && onSuccess()
            }
        } catch (e) {
            clientError = `${e?.message || e}`
            setError(t('POS device is not reachable!') + ` (${clientError})`)
            logPos(false)
        }
    }

    return (
        <div>
            <Form
                ref={formRef}
                onFinish={onSubmit}
                layout={'vertical'}
                size={'small'}
            >
                <Form.Item
                    name={'orderNo'}
                    label={t("Order No")}
                    rules={[{required: true, message: t('Please input your order number!')}]}>
                    <Input />
                </Form.Item>

                <br/>
                <Form.Item>
                    <Button type="primary" htmlType={'submit'}>
                        {t('Cancel') + ' (' + payment?.amount + ' ₺)'}
                    </Button>
                </Form.Item>
                {
                    error && (
                        <Typography.Text style={{color: 'red', fontWeight: 'bold'}}>
                            {error}
                        </Typography.Text>
                    )
                }
            </Form>
        </div>
    )
}